import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import RoleSelectionModal from "./RoleSelectionModal";
import QuestionnaireModal from "./QuestionnaireModal";

const ProfileSetupWrapper = ({ children }) => {
  const [showRoleModal, setShowRoleModal] = useState(false);
  const [showQuestionnaireModal, setShowQuestionnaireModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [userData, setUserData] = useState(null);
  const [checkCompleted, setCheckCompleted] = useState(false);
  const location = useLocation();

  useEffect(() => {
    checkProfileSetup();
  }, [location]);

  const checkProfileSetup = () => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const roles = params.get("roles");
    const permissions = params.get("permissions");
    const userEmail = params.get("user_email") || params.get("email");
    const userId = params.get("user_id");

    // If we have the OAuth callback, handle token storage and role/permission check
    if (token) {
      localStorage.setItem("token", `Bearer ${token}`);
      const user = { email: userEmail, id: userId };
      setUserData(user);

      if (userEmail) localStorage.setItem("user_email", userEmail);
      if (userId) localStorage.setItem("user_id", userId);

      if (!roles || !permissions || roles === "null" || permissions === "null" || roles === "") {
        setShowRoleModal(true);
      } else {
        localStorage.setItem("roles", roles);
        localStorage.setItem("permissions", permissions);
        toast.success("Login successful!");
      }
      window.history.replaceState({}, document.title, "/");
      setCheckCompleted(true);
    } else {
      // Check if the user is already logged in and roles/permissions are missing
      const storedRoles = localStorage.getItem("roles");
      const storedPermissions = localStorage.getItem("permissions");
      const storedToken = localStorage.getItem("token");
      const storedUserId = localStorage.getItem("user_id");

      if (
        storedToken &&
        storedUserId &&
        (!storedRoles || storedRoles === "null" || !storedPermissions || storedPermissions === "[]")
      ) {
        setUserData({ id: storedUserId });
        setShowRoleModal(true);
      } else {
        // Skip the profile setup flow if roles and permissions exist
        setCheckCompleted(true);
      }
    }
  };

  const handleRoleSelect = (role) => {
    setSelectedRole(role);
    setShowRoleModal(false);
    setShowQuestionnaireModal(true);
  };

  const handleQuestionnaireSubmit = (data) => {
    setShowQuestionnaireModal(false);
    toast.success("Profile setup completed successfully!");

    // Reload the page to apply the new role-based settings
    setTimeout(() => {
      window.location.reload();
    }, 1500);
  };

  // Skip rendering children until the check is completed
  if (!checkCompleted && location.search.includes("token")) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      {children}

      {/* Role Selection Modal */}
      <RoleSelectionModal
        isOpen={showRoleModal}
        onClose={() => {}}
        onRoleSelect={handleRoleSelect}
        userId={userData?.id || localStorage.getItem("user_id")}
      />

      {/* Questionnaire Modal */}
      <QuestionnaireModal
        isOpen={showQuestionnaireModal}
        onClose={() => {}}
        onSubmit={handleQuestionnaireSubmit}
        role={selectedRole}
        userId={userData?.id || localStorage.getItem("user_id")}
      />
    </>
  );
};

export default ProfileSetupWrapper;
